


// export const myGetter = {state} =>{
//     return state
// }


export const getEntriesByTerm = (state) => (term = '') =>{
    if(term.length === 0) return state.entries
    return state.entries.filter(entry => entry.text.toLowerCase().includes( term.toLocaleLowerCase()) || entry.monto == term || entry.deuda == term  )

}
export const getEntryById = (state) => (id ) =>{
    
const entry = state.entries.find(entry => entry.id === id)
if(!entry) return
return {...entry}


}


export const getEntries = (state) => () =>{
    const entry = state.entries.forEach()
    if(!entry) return
    return {...entry}
    
    }
 
    
    export const getEntryAll = (state) => ( ) =>{
    
        const entry = state.entries.foreach();
           return entry

     
        
        }
export const updateEntry = () =>{

}
export const createEntry = () =>{

}